// extracted by mini-css-extract-plugin
export default {"kll":"footer_kll__-Y+mn","mai":"footer_mai__Q+y6T","fin":"footer_fin__S3ccl","main":"footer_main__6t0+o","forall":"footer_forall__ulvzh"};